module.exports = __webpack_public_path__ + "img/v2.b04c55b7.png";